import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useCreateReminderWizard } from '@/stores/create-reminder-wizard';

export interface ReminderWizardRoutes {
  isEdit: boolean;
  reminderId: string | null;
  basePath: string;
  groupsPath: string;
  previewPath: string;
  detailPath: string | null;
}

export function useReminderWizardRoutes(): ReminderWizardRoutes {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();

  const routes = useMemo(() => {
    const isEdit = location.pathname.includes('/edit');
    const reminderId = isEdit && id ? id : null;
    const basePath = reminderId ? `/reminders/${reminderId}/edit` : '/reminders/new';

    return {
      isEdit,
      reminderId,
      basePath,
      groupsPath: `${basePath}/groups`,
      previewPath: `${basePath}/preview`,
      detailPath: reminderId ? `/reminders/${reminderId}` : null,
    };
  }, [id, location.pathname]);
  const navigate = useNavigate();
  const active = useCreateReminderWizard((state) => state.createSessionActive);
  const hydratedId = useCreateReminderWizard((state) => state.hydratedFromId);
  useEffect(() => {
    if (
      location.pathname !== routes.basePath &&
      (!active || (routes.isEdit && hydratedId !== routes.reminderId))
    ) {
      void navigate(routes.basePath, { replace: true });
    }
  }, [active, hydratedId, location.pathname, navigate, routes]);
  return routes;
}

export function isReminderWizardFullscreenPath(pathname: string): boolean {
  if (pathname === '/reminders/new' || pathname.startsWith('/reminders/new/')) {
    return true;
  }
  return /^\/reminders\/[^/]+\/edit(?:\/|$)/.test(pathname);
}
